import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import edit from "../../svg/edit.svg";

class HelpAndSupportFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  redirectToGuestWriteToUs = () => {
    const { guestId, history } = this.props;

    if (guestId) {
      window.open("/guestWriteToUs", "_self");
    } else {
      history.push("/newticket"); // Fallback redirection
    }
  };

  render() {
    return (
      <div className="faq-footer">
        <div className="faq-footer-message-left">
          Raise a new support ticket
        </div>
        <div
          className="faq-footer-message-right"
          onClick={this.redirectToGuestWriteToUs}
        >
          <img className="faq-footer-message-right-img" src={edit} alt="" />
          <label className="faq-footer-message-right-label">Write to us</label>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ guestId }) => ({
  guestId,
});

export default connect(mapStateToProps)(withRouter(HelpAndSupportFooter));



// WEBPACK FOOTER //
// ./src/components/CommonComponents/HelpAndSupportFooter.js